<div class="modal-body">
	<button class="close" (click)="closeAndDestroy()">
		<i class="fa-light fa-xmark"></i>
	</button>
	<div class="terms-item">
		<div>
			<h3> {{ 'TERMS.HEADER' | translate }} </h3>
			<cstmsr-terms [userContactCode]="contactCode" [version]="termsData.TermsDocumentLegal"></cstmsr-terms>
		</div>
	</div>
</div>